import type { CourseProgress, RecordProgressInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useCourseProgress(courseId: string) {
  return useQuery({
    queryKey: ['progress', courseId],
    queryFn: () => api.get<CourseProgress>(`/api/progress/${courseId}`),
    enabled: !!courseId,
  })
}

export function useRecordProgress() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ lessonId, data }: { lessonId: string; data: RecordProgressInput }) =>
      api.post(`/api/progress/${lessonId}`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['progress'] })
      qc.invalidateQueries({ queryKey: ['learn'] })
    },
  })
}

export function useCompleteLesson() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (lessonId: string) => api.post(`/api/progress/${lessonId}/complete`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['progress'] })
      qc.invalidateQueries({ queryKey: ['learn'] })
    },
  })
}
